export default "__VITE_ASSET__CIqGqHMk__"